import OrganizationDetail from '@/layouts/OrganizationDetail';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function PrivateTabsOrganizationMainLayoutRoute() {
  return <OrganizationDetail />;
}
